// Accordion.tsx
import { Accordion as MantineAccordion } from '@mantine/core';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface AccordionProps {
  data: {
    title?: string | ReactNode;
    content?: any;
    question?: string;
    answer?: ReactNode;
  }[];
}

const StyledAccordion = styled(MantineAccordion)`
  .mantine-Accordion-item {
    border-bottom: 1px solid #52525b22;
    padding: 10px 0;
    
    &:first-of-type {
      border-top: 1px solid #52525b22;
    }
  }

  .mantine-Accordion-control {
    // padding: 15px;
    background-color: #00000008;
    border-radius: 10px;
    transition: 150ms background-color;

    &:hover {
      background-color: #00000010;
    }

    .mantine-Accordion-label {
      font-size: 18px;
      font-weight: 500;
    }

    .mantine-Accordion-chevron {
      width: 7px;
      height: 7px;
      border-width: 1.5px;
      border-color: #777;
      transition: 300ms transform;
    }
  }

  .mantine-Accordion-content {
    padding: 20px 15px;
    color: var(--mantine-color-gray-7);
    transition: max-height 300ms ease;
  }
`;

const Accordion = ({ data }: AccordionProps) => {
  if (!data?.length) return null;

  const formattedData = data.map(item => ({
    title: item.title || item.question,
    content: item.content || item.answer
  }));

  return (
    <StyledAccordion
      defaultValue="0"
      variant="separated"
      multiple={false}
    >
      {formattedData.map((item, index) => (
        <MantineAccordion.Item key={index} value={index.toString()}>
          <MantineAccordion.Control>{item.title}</MantineAccordion.Control>
          <MantineAccordion.Panel>{item.content}</MantineAccordion.Panel>
        </MantineAccordion.Item>
      ))}
    </StyledAccordion>
  );
};

export default Accordion;